import { Navigate, useLocation } from 'react-router-dom';
import { rewriteLegacyPath } from '../../utils/legacyRoutePaths';

/**
 * Mounted on a renamed route's old path: redirects to the camelCase successor
 * (src/utils/legacyRoutePaths.ts), keeping the rest of the path, the query
 * string and the hash.
 */
const LegacyRouteRedirect = () => {
    const { pathname, search, hash } = useLocation();
    const target = rewriteLegacyPath(pathname);

    // Mounted on a path without a legacy segment, the redirect would loop.
    if (target === pathname) return <Navigate to="/" replace />;

    return <Navigate to={{ pathname: target, search, hash }} replace />;
};

export default LegacyRouteRedirect;
